import React, { Component } from 'react';

class ExcelForm extends Component {
  render() {
    return (
      <div>
        <form onSubmit={ e => {e.preventDefault(); this.props.onSubmit(this.file.files[0], this.columns.value)}} >
          <p>
            <label>Excel</label>
            <input type="file" name="excelFile" ref={n=>this.file = n} />
          </p>
          <p>
            <label>Liczba nagłówków</label>
            <input type="number" name="columns" ref={n=>this.columns = n} />
          </p>
          <button type="submit">Wyślij</button>
        </form>
      </div>
    );
  }
}

export default ExcelForm;



// WEBPACK FOOTER //
// ./src/modules/Admin/components/ExcelForm.js